type OptionWithTag = {
  tag?: { label: string; type: string } | null
}

/**
 * Applies the `experiment.ppUpgradeForLessV2` tag gate on funnel data.
 *
 * When the "withUpgrade" arm is active the option tags are hidden, so the
 * picker option components stay free of experiment checks. Mobile plan options
 * keep their tags regardless of the experiment.
 */
export const applyUpgradeForLessTagGate = <TOption extends OptionWithTag>(
  options: TOption[],
  stepId: string,
  experiments: Record<`experiment.${string}`, string>,
): TOption[] => {
  if (
    experiments['experiment.ppUpgradeForLessV2'] !== 'withUpgrade' ||
    stepId === 'mobile_plan'
  ) {
    return options
  }

  return options.map((option) => ({ ...option, tag: null }))
}
